<template>
  <div class="wrapper">
    <div class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-33 md-small-size-66 md-xsmall-size-100 md-medium-size-40 mx-auto"
          >
            <login-card header-color="green">
              <h4 slot="title" class="card-title">Writers' Den</h4>
              <md-field slot="inputs" class="md-form-group">
                <md-icon>email</md-icon>
                <label>Email...</label>
                <md-input v-model="email" type="email" />
              </md-field>
              <md-field slot="inputs" class="md-form-group">
                <md-icon>lock_outline</md-icon>
                <label>Password...</label>
                <md-input v-model="password" type="password" />
              </md-field>
              <div slot="inputs" class="text-danger text-center">{{error}}</div>
              <div slot="footer">
                <md-button class="md-simple md-success md-lg" @click="login">Login</md-button>
              </div>
            </login-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LoginCard } from "@/components";
import Mixins from "@/plugins/basicMixins";
import firebase from "firebase";

export default {
  components: {
    LoginCard
  },
  mixins: [Mixins.HeaderImage],
  bodyClass: "login-page",
  data() {
    return {
      image: require("@/assets/img/profile_city.jpg"),
      email: null,
      password: null,
      error: null
    };
  },
  methods: {
    login() {
      const vm = this;
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(function(user) {
          // Do some stuff
        })
        .catch(function(error) {
          vm.error = error.message;
        });
    }
  }
};
</script>

<style lang="css"></style>
